import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Supplier\FetchItemsBySupplierByIdController::__invoke
* @see app/Http/Controllers/Supplier/FetchItemsBySupplierByIdController.php
* @route '/api/supplier-items/{supplier}'
*/
const FetchItemsBySupplierByIdController = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemsBySupplierByIdController.url(args, options),
    method: 'get',
})

FetchItemsBySupplierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/supplier-items/{supplier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Supplier\FetchItemsBySupplierByIdController::__invoke
* @see app/Http/Controllers/Supplier/FetchItemsBySupplierByIdController.php
* @route '/api/supplier-items/{supplier}'
*/
FetchItemsBySupplierByIdController.url = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier: typeof args.supplier === 'object'
        ? args.supplier.id
        : args.supplier,
    }

    return FetchItemsBySupplierByIdController.definition.url
            .replace('{supplier}', parsedArgs.supplier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Supplier\FetchItemsBySupplierByIdController::__invoke
* @see app/Http/Controllers/Supplier/FetchItemsBySupplierByIdController.php
* @route '/api/supplier-items/{supplier}'
*/
FetchItemsBySupplierByIdController.get = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemsBySupplierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Supplier\FetchItemsBySupplierByIdController::__invoke
* @see app/Http/Controllers/Supplier/FetchItemsBySupplierByIdController.php
* @route '/api/supplier-items/{supplier}'
*/
FetchItemsBySupplierByIdController.head = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchItemsBySupplierByIdController.url(args, options),
    method: 'head',
})

export default FetchItemsBySupplierByIdController